import JurisdictionTotal from '../../models/jurisdictionTotal';
import Invoice from '../../models/invoice';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import InvoiceService from '../../services/invoiceService';
import { MessageQueService } from '../../services/index';

@Component({
  selector: 'app-invoice-report',
  templateUrl: './invoiceReport.component.html',
  styleUrls: ['./invoiceReport.component.scss'],
  providers: [InvoiceService, MessageQueService]
})
export default class InvoiceReportComponent implements OnInit {
  constructor(private invoiceService: InvoiceService, private msgSvc: MessageQueService, private route: ActivatedRoute) {
    this.route.params.subscribe((params: any) => {
      this.startDate = params['startDate'] as string;
      this.endDate = params['endDate'] as string;
      this.invoiceNumber = params['invoiceNumber'] as string;
    });
  }

  ngOnInit() {
    this.msgSvc.setControlKey();
    this.invoiceService.getInvoice(this.invoiceNumber, this.startDate, this.endDate)
      .subscribe((invoice: Invoice) => {
        this.invoice = invoice;
        this.jurisdictionTotals = invoice.jurisdictionTotals;
        this.totalRequestCount = invoice.totalRequestCount;
        this.totalInvoiceAmount = invoice.totalInvoiceAmount;
      });
  }

  get currentDate() {
    return new Date();
  }

  startDate: string;
  endDate: string;
  invoiceNumber: string;
  invoice: Invoice;
  totalRequestCount: number;
  totalInvoiceAmount: number;
  jurisdictionTotals: JurisdictionTotal[];
}



// WEBPACK FOOTER //
// ./src/app/invoiceReport/invoiceReport.component.ts